// extracted by mini-css-extract-plugin
export default {"Preloader":"Preloader_Preloader__vxLDy"};